const getSearchDataService = () => {
  return new Promise((resolve, reject) => {
    const data = localStorage.getItem('cruise')
    data ? resolve(JSON.parse(data)) : reject()
  })
}

const openModalService = () => {
  return new Promise((resolve, reject) => {
    window.addEventListener('storage', () => {
      const openModalFlag = localStorage.getItem('showModal')
      openModalFlag ? resolve(JSON.parse(openModalFlag)) : reject()
    })
  })
}
const resetStorageData = () => {
  localStorage.removeItem('cruise')
  localStorage.removeItem('showModal')
}
export {
  getSearchDataService,
  openModalService,
  resetStorageData
}
